/**
 * @generated SignedSource<<185e1ac03013641d630a8389ae368961>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TaxResidencyCountriesListQuery$variables = Record<PropertyKey, never>;
export type TaxResidencyCountriesListQuery$data = {
  readonly countriesTaxRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly countryCode: string;
        readonly id: string;
        readonly isTinRequired: boolean;
        readonly maxLength: number;
        readonly minLength: number;
        readonly placeholder: string;
        readonly title: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type TaxResidencyCountriesListQuery = {
  response: TaxResidencyCountriesListQuery$data;
  variables: TaxResidencyCountriesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CountriesTaxRulesConnection",
    "kind": "LinkedField",
    "name": "countriesTaxRules",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CountriesTaxRuleEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CountriesTaxRule",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minLength",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxLength",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "placeholder",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTinRequired",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaxResidencyCountriesListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TaxResidencyCountriesListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "827ddc3aaa7ea8f78f3e76a33dee13a6",
    "id": null,
    "metadata": {},
    "name": "TaxResidencyCountriesListQuery",
    "operationKind": "query",
    "text": "query TaxResidencyCountriesListQuery {\n  countriesTaxRules {\n    edges {\n      node {\n        id\n        countryCode\n        title\n        minLength\n        maxLength\n        placeholder\n        isTinRequired\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "76c3e0c1d23a2f7d7a4dc6da219b5ba5";

export default node;
